module.exports = {
    "className": "VoucherCardType",
    "limit": 10,
    "showExport": false,
    "columns": [
      {
        "columnName": "objectId",
            "type": "string"
      },
      {
        "columnName": "name",
        columnLabel: "Card Type",
        "type": "string"
      },
      {
        "columnName": "createdAt",
            "type": "Date"
      },
      {
        "columnName": "updatedAt",
            "type": "Date"
      }
    ]
}  


// WEBPACK FOOTER //
// ./components/EVoucherCardType/VoucherCardTypeSchema.js